import { useContext } from "react"
import { WorkTaskProviderContext } from ".."

export function useWorkTask() {
    return useContext(WorkTaskProviderContext)
}
